/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayIcon16Solid = forwardRef('MediaUiAPlayIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13.238 6.598 5.52 1.812C4.42 1.131 3 1.922 3 3.214v9.572c0 1.293 1.42 2.083 2.52 1.402l7.718-4.786a1.65 1.65 0 0 0 0-2.804Z" })));
});
